import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "flag-icons-gb",
  viewBox: "0 0 640 480"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"#012169\" d=\"M0 0h640v480H0z\"></path><path fill=\"#FFF\" d=\"m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0z\"></path><path fill=\"#C8102E\" d=\"m424 281 216 159v40L369 281zm-184 20 6 35L54 480H0zM640 0v3L391 191l2-44L590 0zM0 0l239 176h-60L0 42z\"></path><path fill=\"#FFF\" d=\"M241 0v480h160V0zM0 160v160h640V160z\"></path><path fill=\"#C8102E\" d=\"M0 193v96h640v-96zM273 0v480h96V0z\"></path>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_7]))
}
export default { render: render }